export default __webpack_public_path__ + "static/media/Lumico.c434a9b0.svg";